// Backend user_type values:
//   1, 2 → client
//   3, 4, 5, 6, 7 → agent (5 = AI agent / system / transfer messages, 7 = agent-to-agent)
export const CLIENT_USER_TYPES = [1, 2] as const;
export const AGENT_USER_TYPES = [3, 4, 5, 6, 7] as const;

export const isClientUserType = (t: number | null | undefined): boolean =>
  t === 1 || t === 2;

export const isAgentUserType = (t: number | null | undefined): boolean =>
  t === 3 || t === 4 || t === 5 || t === 6 || t === 7;
